import { EmptyGraphic } from 'app/components/empty-graphic';
import { images } from 'app/design/images';
import { Box } from 'app/design/primitives/box';
import { useScopedTranslation } from 'app/hooks/i18n';
import { useNavigation } from 'app/hooks/navigation';
import { ListingType, type TransactionMode } from 'app/types/listing';
import { LoanType } from 'app/types/loan';

export function SavingsEmptyView({
  containerWidth,
  transactionMode,
  type,
}: Readonly<{ containerWidth: number; transactionMode?: TransactionMode; type: LoanType }>) {
  const { t } = useScopedTranslation();
  const navigation = useNavigation();

  return (
    <Box alignSelf="center" width={containerWidth}>
      <EmptyGraphic
        button={{
          children: transactionMode
            ? t(`emptyByTransaction.${transactionMode}.${type}.primaryButtonText`)
            : t(`empty.${type as string}.primaryButtonText`),
          onPress: () =>
            navigation.navigate('billboard', {
              screen: 'all-listings',
              params: { type: type === LoanType.Borrowing ? ListingType.offer : ListingType.request },
            }),
        }}
        primary={
          transactionMode
            ? t(`emptyByTransaction.${transactionMode}.${type}.firstLine`)
            : t(`empty.${type as string}.firstLine`)
        }
        secondary={
          transactionMode
            ? t(`emptyByTransaction.${transactionMode}.${type}.secondLine`)
            : t(`empty.${type as string}.secondLine`)
        }
        source={images.savingMoney}
      />
    </Box>
  );
}
